import { Component } from '@angular/core';

/** Entry point propio de Hormigón Mixer. */
@Component({
  selector: 'app-hormigon-mixer-dashboard-entry',
  template: '<app-hormigon-dashboard></app-hormigon-dashboard>',
  standalone: false,
})
export class HormigonMixerDashboardEntryComponent {}
